import { de, enUS, type Locale } from 'date-fns/locale';

export const dateLocales: Record<string, Locale> = {
  de: de,
  en: enUS,
};
